// extracted by mini-css-extract-plugin
export default {"scratcherSuccessPage":"ScratcherSuccessPage_scratcherSuccessPage__h4iN6"};